import React, { useState, useRef, useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDownOutline } from 'ionicons/icons';
import './Dropdown.css';

/**
 * Generic dropdown select component.
 *
 * @param {Array<{key: string, label: string}>} options
 * @param {string} value - Currently selected option key
 * @param {function} onChange - Called with the selected option key
 * @param {string} [className] - Additional class on the wrapper
 * @param {string} [align='left'] - Menu alignment: 'left' or 'right'
 */
const Dropdown = ({ options = [], value, onChange, className = '', align = 'left' }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const selected = options.find(o => o.key === value);

  return (
    <div ref={wrapperRef} className={`dropdown-wrapper ${className}`}>
      <button
        className={`dropdown-trigger ${open ? 'open' : ''}`}
        onClick={() => setOpen(prev => !prev)}
        type="button"
      >
        <span className="dropdown-trigger-label">{selected?.label ?? value}</span>
        <IonIcon icon={chevronDownOutline} className="dropdown-trigger-icon" />
      </button>

      {open && (
        <div className={`dropdown-menu ${align === 'right' ? 'align-right' : 'align-left'}`}>
          {options.map(opt => (
            <div
              key={opt.key}
              className={`dropdown-menu-item ${opt.key === value ? 'selected' : ''}`}
              onClick={() => { onChange(opt.key); setOpen(false); }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
